module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tr-535c328e67d2cd2625438f992176adcf.svg";